export const ActionTypes = {
    FETCH_JOBS: "FETCH_JOBS",
    SET_JOBS: "SET_JOBS",
    SET_JOB: "SET_JOB",
    GET_JOBS_BY_TYPE: "GET_JOBS_BY_TYPE",
    FETCH_APPLICATIONS: "FETCH_APPLICATIONS",
    SET_APPLICATIONS: "SET_APPLICATIONS"
};